export * from './IAnimObject';